import { render, staticRenderFns } from "./indexTabConfigManagement.vue?vue&type=template&id=7109bb8c&scoped=true"
import script from "./indexTabConfigManagement.vue?vue&type=script&lang=js"
export * from "./indexTabConfigManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7109bb8c",
  null
  
)

export default component.exports